import React, { useState } from 'react'
import { AllUserComponent } from '../Components/User/AllUserComponent';
import { EditUserComponent } from '../Components/User/EditUserComponent';
import { AllReservesComponent } from '../Components/Reserves/AllReservesComponent';
import { AReserveComponent } from '../Components/Reserve/AReserveComponent';

export const User = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [userId, setUserId] = useState(0);
    const [userFullName, setUserFullName] = useState(0);
    const [reserveId, setReserveId] = useState(0);
    // ======================================================================
    return (
        <>
            {view == "All" ?
                <AllUserComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onEdit={(id, fullName) => { setUserId(id); setUserFullName(fullName); setView("Edit") }}
                    onRowDeleted={() => setVersion(version + 1)}
                    onReservesClick={(id, fullName) => { setUserId(id); setUserFullName(fullName); setView("Reserves") }}
                /> : <></>
            }
            {
                view === "Edit" ?
                    <EditUserComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        id={userId}
                        onRowUpdated={() => { setView("All"); setVersion(version + 1); }}
                        cancelEdit={() => { setView("All"); }}
                    /> : <></>
            }
            {
                view === "Reserves" ?
                    <AllReservesComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        forCurrentUser={false}
                        userId={userId}
                        userFullName={userFullName}
                        version={version}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        isShowBack={true}
                        onBackClick={() => setView("All")}
                        onItemClick={(id) => { setReserveId(id); setView('AReserve') }}
                    /> : <></>
            }
            {view == "AReserve" ?
                <AReserveComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    reserveId={reserveId}
                    onBackClick={() => { setView('Reserves') }}
                /> : <></>
            }

        </>
    )
}

